export const MY_TASKS_CALENDAR_RQ_KEY = 'myTasksCalendarTasks';
export const MY_TASKS_CATCHUP_RQ_KEY = 'myTasksCatchUpTasks';
export const MY_TASKS_VISIBLE_CATCHUP_RQ_KEY = 'myTasksVisibleCatchUpTasks';

export const MY_PORTFOLIO_TASKS_CATCHUP_RQ_KEY = 'myPortfolioCatchUpTasks';
export const MY_PORTFOLIO_VISIBLE_CATCHUP_RQ_KEY = 'myPortfolioVisibleCatchUpTasks';
export const MY_PORTFOLIO_TASKS_CALENDAR_RQ_KEY = 'myPortfolioCalendarTasks';
